/**
 * Same Day / Next Day delivery postcode check on the Shipping & Delivery page
 * (blocks/_shipping-postcode.liquid, Australian panel).
 *
 * Ported from the legacy Magento page's inline `search_postcodes()`. The list
 * of eligible postcodes (`data-postcodes`) and the two result messages are the
 * block's theme editor settings, so a change to the delivery area or the copy
 * is an edit there, not a change here.
 */
if (!customElements.get('forcast-postcode-check')) {
  customElements.define(
    'forcast-postcode-check',
    class extends HTMLElement {
      connectedCallback() {
        this.postcodes = new Set((this.dataset.postcodes || '').split(/[\s,]+/).filter(Boolean));
        this.form = this.querySelector('form');
        this.result = this.querySelector('[role="status"]');
        this.form?.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      onSubmit = (event) => {
        event.preventDefault();
        const postcode = new FormData(this.form).get('postcode')?.toString().trim() ?? '';
        if (!this.result) return;

        this.result.textContent = this.postcodes.has(postcode)
          ? this.dataset.eligibleMessage || 'Your postcode is eligible for Same Day and Next Day Delivery.'
          : this.dataset.ineligibleMessage ||
            'Unfortunately Same Day and Next Day Delivery is currently unavailable in your area.';
      };
    }
  );
}
